import React, {PureComponent} from 'react'
import Link from 'gatsby-link'
import css from 'emotion';
import styled from 'react-emotion';

const ChapterContainer = styled.li`

    & h2 {
        margin-bottom: .5rem;
    }

    & button {
        display: flex;
        border: 0 none;
        background-color: transparent;
        padding: 5px;
        width: 100%;
        justify-content: center;
        align-items: center;
        
        & i {
            font-size: .65em;
            margin-left: 3rem;
        }

        &:hover {
            background: #f4f4f4;
            border-radius: 10px;
        }

        &:focus {
            outline: none;
        }
    }

    border-bottom: 1px dashed #ccc;
    padding: 20px;

    &:last-child {
        border-bottom: 0 none;
    }

    & div {
        font-size: .9rem;
    }

    & p {
        margin-bottom: .65rem;
    }
`

const PageListItem = styled.li`
    & a {
        text-decoration: none;
        color: #222;

        & i {
            font-size: .65em;
            margin-left: 5px;
        }
    }
`

export default class ChapterDisplay extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
    }

    handleOpen = () => {
        this.setState({open: !this.state.open });
    }

    render() {
        return (
            <ChapterContainer>
                <h2>
                    <button onClick={this.handleOpen}><span>{`${this.props.chapter.chapterNumber < 999999999 ? `Chapter ${this.props.chapter.chapterNumber}:` : ""} ${this.props.chapter.title}`}</span> {this.state.open ? <i className="icon-279" /> : <i className="icon-278" /> }</button>
                </h2>
                <div dangerouslySetInnerHTML={{ __html: this.props.chapter.subtitle.childMarkdownRemark.html}} />
                { this.state.open ? 
                    <ul>
                        { this.props.chapter.page.sort((a,b) => a.pageNumber - b.pageNumber).map((page) => 
                            <PageListItem key={page.id}>
                                <Link to={`/${this.props.chapter.slug}/${page.path}`}>{`${page.pageNumber < 1000000000 ? `Page ${page.pageNumber}.` : ""} ${page.title}`} <i className="icon-276" /></Link>
                            </PageListItem>
                        ) }
                    </ul>
                : null }
            </ChapterContainer>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/ChapterDisplay/index.js